module.exports = __webpack_public_path__ + "images/default_avatars/jokul@2x-94e515417392c6f8269b7c5aab52bdea.jpg";